var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comments-tab" },
    [
      _vm.isSubmitting || _vm.isLoadingUsers
        ? _c("pui-loader-spinner", {
            attrs: {
              title: _vm.$t("commentLightbox.loader.title"),
              message: _vm.$t("commentLightbox.loader.message"),
            },
          })
        : _c(
            "div",
            [
              _vm.commentDetails.comment
                ? _c(
                    "div",
                    { staticClass: "comments-tab__comment" },
                    [
                      _c(
                        "pui-comment",
                        {
                          attrs: {
                            "author-username": _vm.modifiedByName,
                            "creation-date":
                              _vm.commentDetails.comment.createdAt,
                            "edit-date": _vm.commentDetails.comment.modifiedAt,
                            comment: _vm.commentDetails.comment.text,
                          },
                        },
                        [
                          _vm.showTaggedUsersList
                            ? _c("template", { slot: "additional-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "comments-tab__comment__tagged-users",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.taggedUsersList) + " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.isAllowedToEditComments
                        ? _c("hr", {
                            staticClass: "comments-tab__comment__separator",
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAllowedToEditComments
                ? _c(
                    "pui-form",
                    {
                      staticClass: "comments-tab__form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSubmission.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pui-form-grid-row" },
                        [
                          _c(
                            "pui-form-group",
                            {
                              directives: [
                                {
                                  name: "pui-form-grid-column",
                                  rawName: "v-pui-form-grid-column",
                                  value: { s: 12 },
                                  expression: "{s:12}",
                                },
                              ],
                              attrs: {
                                label: _vm.fields.comment.label,
                                "is-valid": _vm.fields.comment.isValid,
                              },
                            },
                            [
                              _c("pui-form-textarea", {
                                attrs: {
                                  placeholder: _vm.fields.comment.placeholder,
                                  "is-valid": _vm.fields.comment.isValid,
                                  rows: 4,
                                  grow: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleValidationForField(
                                      "comment"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.fields.comment.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.fields.comment, "value", $$v)
                                  },
                                  expression: "fields.comment.value",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "error-message" },
                                  slot: "error-message",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errorMessage(_vm.fields.comment.value)
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "pui-form-group",
                            {
                              directives: [
                                {
                                  name: "pui-form-grid-column",
                                  rawName: "v-pui-form-grid-column",
                                  value: { s: 12, l: 8 },
                                  expression: "{s:12, l:8}",
                                },
                              ],
                              attrs: {
                                label: _vm.fields.people.label,
                                "is-valid": _vm.fields.people.isValid,
                              },
                            },
                            [
                              _c("uam-user-input", {
                                attrs: {
                                  "initial-value": _vm.initialUserList,
                                  "is-valid": _vm.fields.people.isValid,
                                },
                                on: { "update:users": _vm.updateUsers },
                              }),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "error-message" },
                                  slot: "error-message",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "commentLightbox.errorMessage.errorOccurred"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "comments-tab__form__footer pui-form-grid-column-12@s",
                            },
                            [
                              _c(
                                "pui-button",
                                {
                                  attrs: { state: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("close-lightbox", false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("commentLightbox.actions.cancel")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "pui-button",
                                {
                                  staticClass:
                                    "comments-tab__form__footer__button",
                                  attrs: {
                                    disabled: _vm.isSubmitButtonDisabled,
                                    type: "submit",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.commentDetails.comment
                                          ? _vm.$t(
                                              "commentLightbox.actions.update"
                                            )
                                          : _vm.$t(
                                              "commentLightbox.actions.add"
                                            )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }